module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7508/images/default-avatar.png"